"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginArgsValidator = void 0;
var suretype_1 = require("suretype");
var loginArgsSchema = suretype_1.v.object({
    challenge: suretype_1.v.string().required()
});
exports.loginArgsValidator = (0, suretype_1.compile)(loginArgsSchema);
